<template>
  <div class="supply">
    
    <div class="frame">
      <div class="big-title">
        <p>运营框架</p>
        <div class="line"></div>
        <div class="desc">
          一站式智能化场馆建设服务
        </div>
      </div>
      <img src="../../static/images/solution/fitness16.png" alt="" />
    </div>
    
    <div class="hard">
      <div class="big-title">
        <p>多种营销方式</p>
        <div class="line"></div>
        <div class="desc">
          利用营销方式的多样化增加用户粘性，促进运营推广
        </div>
      </div>
      <div class="hard-box">
        <div class="hard-cont">
          <div class="hard-item" v-for="(item,index) in hardArr" :key="index">
            <img :src="item.img" alt="" />
            <h2>{{ item.title }}</h2>
          </div>
        </div>
      </div>
    </div>
    <div class="system">
      <div class="big-title">
        <p>核心价值</p>
        <div class="line"></div>
        <div class="desc">
          严格把控每个服务环节，带给您无微不至的服务体验
        </div>
      </div>
      <div class="system-box">
        <div class="system-item" v-for="(item,index) in systemArr" :key="index">
          <img :src="item.img" alt="" />
          <div>
              <h5>{{ item.title }}</h5>
              <h6>{{ item.desc }}</h6>
          </div>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
export default {
  data() {
    return {
      hardArr: [
        {
          id: 0,
          img: require("../../static/images/solution/fitness2.png"),
          title: "预约签到",
        },
        {
          id: 1,
          img: require("../../static/images/solution/fitness3.png"),
          title: "会员管理",
        },
        {
          id: 2,
          img: require("../../static/images/solution/fitness4.png"),
          title: "课程管理",
        },
        {
          id: 3,
          img: require("../../static/images/solution/fitness5.png"),
          title: "财务管理",
        },
        {
          id: 4,
          img: require("../../static/images/solution/fitness6.png"),
          title: "统计报表",
        },
        {
          id: 2,
          img: require("../../static/images/solution/fitness7.png"),
          title: "员工管理",
        },
        {
          id: 3,
          img: require("../../static/images/solution/fitness8.png"),
          title: "门店管理",
        },
        {
          id: 4,
          img: require("../../static/images/solution/fitness9.png"),
          title: "更衣柜管理",
        },
      ],
      //核心价值
      systemArr: [
        {
          id: 0,
          title:'稳定好用的管理系统 营销获客更简单',
          desc: "全新的微服务架构，保障系统7*24小时稳定运行无异常，不再担心数据出错和丢失，灵活扩展，完美适用各种营销场景",
          img: require("../../static/images/solution/fitness10.png"),
        },
        {
          id: 1,
          title:'强大的会员卡管理功能',
          desc: "精心打造的会员卡管理模块，涵盖行业内所有场景，强大的管理功能，灵活的规则设置，满足从单店到品牌连锁的任何需求",
          img: require("../../static/images/solution/fitness11.png"),
        },
        {
          id: 2,
          title:'1秒预约，5秒消课，拒绝混乱',
          desc: "系统数字化管理，搭配人脸识别认证，课程安排看得见，课程业绩算得清，避免私教管理混乱，消课有据可依，业绩有账可查",
          img: require("../../static/images/solution/fitness12.png"),
        },
        {
          id: 3,
          title:'健身数字化，让变化看得见',
          desc: "健身设备智能化，运动数据及时推送，与运动专业人士深度合作，数据内容科学直观。结合私教服务探索更多服务模式，提升服务专业性",
          img: require("../../static/images/solution/fitness13.png"),
        },
        {
          id: 4,
          title:'营收分析，1分钱也不会出错',
          desc: "财务系统参照支付宝设计并针对行业优化适配，熟悉的操作界面5秒上手，关键数据一览无余，搭配精确无误的统计功能，营收统计省心省力",
          img: require("../../static/images/solution/fitness14.png"),
        },
        {
          id: 6,
          title:'提升服务质量，强化品牌形象',
          desc: "丰富的智能设备，提升场馆全方位的使用体验，并且降低运营成本，打造品牌独特竞争力",
          img: require("../../static/images/solution/fitness15.png"),
        },
      ],
    };
    },
    methods:{
      //立即咨询
    jumpService() {
      this.$addConsult()
    },
  },
};
</script>

<style lang="stylus" scoped>
.supply {
  margin: 80px 0 0;
}

.hard {
  width: 1400px;
  margin: 0 auto;
  padding-bottom: 80px;

  .hard-box {
    width :1400px;
    height :408px;
    background: url('../../static/images/solution/fitness1.png');
    display :flex;
    justify-content :flex-end
  }
  .hard-cont{
    padding :48px 0 0 0;
    width :688px;
    display: flex;
    flex-wrap:wrap;
    justify-content :flex-start 
  }

  .hard-item {
    width: 140px;
    height: 140px;
    background: rgba(255,255,255,0.3);
    border-radius: 4px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin:0 32px 32px 0
    img{
      margin :24px 0 16px 0
    }
    h2 {
      font-size: 18px;
      font-weight: bold;
      color: #FFFFFF;
      line-height: 28px;
    }

  }
}
.frame{
  text-align :center
}



.system {
  width: 1400px;
  margin: 0 auto;
  padding-bottom: 80px;

  .system-box {
    display: flex;
    flex-wrap: wrap;
    justify-content :space-between
  }

  .system-item {
    width: 451px;
    height: 285px;
    padding :24px;
    background: #FFFFFF;
    box-shadow: 0px 5px 17px 3px rgba(185, 185, 185, 0.15);
    border-radius: 4px;
    margin-bottom: 24px;
    text-align :center
    img{
      width :58px;
      height :58px
      margin:0 0 24px 0
    }

    p {
      font-size: 20px;
      font-weight: 400;
      color: #333333;
      margin-top:40px;
    }
    h5{
      font-size: 18px;
      font-weight: bold;
      color: #333333;
      line-height: 28px;
      margin :0 0 23px 0
    }
    h6{
      font-size: 14px;
      font-weight: 400;
      color: #666666;
      line-height: 28px;
    }
  }

  .system-item:hover {
    box-shadow: 0px 5px 17px 3px rgba(230, 192, 76, 0.15);
  }
}

.big-title {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  text-align: center;

  p {
    font-size: 30px;
    font-weight: bold;
    color: #333333;
  }

  .line {
    width: 42px;
    height: 2px;
    background: #FFC000;
    border-radius: 1px;
    margin-top: 29px;
  }

  .desc {
    font-size: 16px;
    font-weight: 400;
    color: #333;
    text-align: center;
    margin: 22px 0 58px;
    line-height: 28px;
  }
}


.clearfix:before, .clearfix:after {
  content: '';
  display: table;
  clear: both;
}
</style>


// WEBPACK FOOTER //
// src/components/pc/solutionFitness.vue